import { Tag } from 'antd';
import { CHECKLIST_LABELS } from '../policies/verification-form.policy';
import type { WorkOrderVerificationView } from '../work-orders.api';

/** Every attempt, newest first. A failed one is why the order went back to in progress. */
export function VerificationAttempts({ attempts }: { attempts: WorkOrderVerificationView[] }) {
  if (attempts.length === 0) return <p className="m-0 text-muted">Nobody has verified this work yet.</p>;
  const newestFirst = [...attempts].sort((a, b) => b.createdAt.localeCompare(a.createdAt));

  return (
    <ul aria-label="Verification attempts" className="m-0 flex list-none flex-col gap-4 p-0">
      {newestFirst.map((attempt) => (
        <li key={attempt.id} className="flex flex-col gap-1 rounded-md border border-line p-3">
          <div className="flex flex-wrap items-center gap-2">
            <Tag color={attempt.outcome === 'passed' ? 'success' : 'error'}>{attempt.outcome === 'passed' ? 'Passed' : 'Failed'}</Tag>
            <span className="text-sm text-muted">{new Date(attempt.createdAt).toLocaleString('en-KE')}</span>
            <span className="text-sm text-muted">{attempt.photoUploadIds.length} photo(s)</span>
          </div>
          {attempt.reason && <p className="m-0 text-sm">{attempt.reason}</p>}
          <ul className="m-0 list-none p-0 text-sm">
            {attempt.checklist.map((entry) => (
              <li key={entry.item}>
                {entry.result === 'pass' ? 'Pass' : 'Fail'} · {CHECKLIST_LABELS[entry.item]}
                {entry.note ? ` — ${entry.note}` : ''}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
}
